import type { ReactNode } from 'react';

type TagProps = {
  children: ReactNode;
  tone?: 'primary' | 'accent' | 'secondary' | 'neutral';
  className?: string;
};

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-900 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  neutral: 'bg-background-200 text-foreground-700 border-background-300',
};

export default function Tag({ children, tone = 'neutral', className = '' }: TagProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-label whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}